import { useSelector } from '../../../reduxToolkit/typedRedux';

export function useRegistrationFilter() {
  const fields = useSelector((state) => state.common.registrationFields).filter(
    (f) => f.isPublic && !f.isHidden && (f.fieldType !== 'text' || f.textValueOptions?.length > 0)
  );

  return {
    fields,
  };
}
